'use client';
import React from "react";
import Image from "next/image";

// `fill` makes the flag cover a positioned parent (e.g. a round badge) instead of rendering at 20x14
export function FlagImage({ code, alt, fill = false }: { code: string; alt: string; fill?: boolean }) {
  const [visible, setVisible] = React.useState(true);
  if (!visible) return null;
  return (
    <Image
      src={`/flags/${code.toLowerCase()}.svg`}
      alt={alt}
      {...(fill ? { fill: true, className: "object-cover" } : { width: 20, height: 14 })}
      onError={() => setVisible(false)}
    />
  );
}
